import {
  SELECT_TYPES,
  get_headers,
  get_project_id
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import question_form_mixin from "@/utils/mixins/question_form_mixin";
import dependent_questions_mixin from "@/utils/mixins/dependent_questions_mixin";
import data_handling_mixin from "@/utils/mixins/data_handling_mixin";
import validation_mixin from "@/utils/mixins/validation_mixin";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

export default {
  name: "ManageQuestions",
  mixins: [
    alert_mixin,
    formatting_mixins,
    question_form_mixin,
    dependent_questions_mixin,
    data_handling_mixin,
    validation_mixin
  ],
  components: {
      NavigationBackButton,
    },

  data: () => ({
    selected_questions: [],
    select_all: false,
    form_id: "",
    section_id: "",
    question_list: [],
    data_points: [],
    data_point_tags: {},
    table_safe_question_list: [],
    question_table_headers: [],
    headers: "",
    project_id: get_project_id(),
    question_types: [],
    question_forms: [{
      id: 1,
      question: "",
      question_number: "",
      question_type: "",
      is_mandatory: "",
      show_option_inputs: false,
      option_inputs: ["", ""],
      data_point_id: null,
      available_tags: [],
      selected_tag: null,
      dependant_questions: [],
    }],
    current_edit_question: {
      id: null,
      question: "",
      question_description: "",
      question_number: "",
      question_type: "",
      show_option_inputs: false,
      option_inputs: [],
      data_point_id: null,
      selected_tag: null,
      available_tags: [],
      dependant_questions: [],
    },
    current_dependent_questions: [],
    current_edit_index: null,
    show_create_modal: false,
    show_edit_modal: false,
    show_dependent_modal: false,
    show_manage_dependent_modal: false,
    current_main_question_id: null,
    new_dependent_question: {
      question_text: "",
      question_type_id: "",
      data_point_id: null,
      tag_id: null,
      question_number: "",
      options: [{ choice: "" }, { choice: "" }],
      trigger_condition: "",
      is_mandatory: false,
    },
    is_editing_dependent: false,
    current_editing_dependent_id: null,
    dependent_loading: false,

    update_dependent_loading: false,
    select_types: SELECT_TYPES,
    parent_question: null
  }),

  computed: {
    is_all_selected() {
      return (
        this.selected_questions.length === this.table_safe_question_list.length &&
        this.table_safe_question_list.length > 0
      );
    },

    parent_question_options() {
      if (!this.current_main_question_id) return [];
      const parent_question = this.question_list.find(q => q.id === this.current_main_question_id);
      if (!parent_question || !this.is_select_type(parent_question.question_type)) return [];
      return parent_question.multi_select_choices?.map(choice => choice.choice) || [];
    },

    is_select_type() {
      return (question_type) => {
        return this.select_types.includes(question_type);
      };
    }
  },

  mounted() {
    this.headers = get_headers();
    this.fetch_all_data_point_tags();
    this.form_id = this.$route.query.form_id;
    this.section_id = this.$route.query.section_id;
    this.get_question_types();
    this.get_questions();
    this.get_data_points();
  }
};